import React, { useRef } from 'react';
import { Input, InputNumber } from 'antd';

interface InputBorderNoneProps {
  type?: string;
  placeholder: string;
  label?: string | null;
  className?: string | null;
  calculateBalance?: boolean;
  valuePercentage?: number;
  onChange?: any;
  value?: any;
  height?: string | number;
  formatter?: 'currency' | any;
  max?: number;
  min?: number;
  color?: 'default' | 'warning' | 'bold' | 'bold-lith';
  disabled?: boolean;
  onBlur?: any;
  onKeyDown?: any;
  suffix?: any;
  defaultValue?: any;
}

const InputBorderNone = ({
  type,
  placeholder,
  label,
  calculateBalance,
  className,
  valuePercentage,
  onChange,
  value,
  height = 'auto',
  formatter,
  color,
  onBlur,
  ...props
}: InputBorderNoneProps) => {
  const ref = useRef<any>();

  const getFormatter: any = (value: string) => {
    if (value && formatter === 'currency')
      return `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '';
  };

  return (
    <div className="InputBorderNone" style={{ height }}>
      {label && <p className="body-card">{label}</p>}
      {type === 'number' && (
        <InputNumber
          ref={ref}
          value={value}
          controls={false}
          className={`input input-transparent body-placeholder ${className} ${color}`}
          placeholder={placeholder}
          style={{ width: '100%' }}
          formatter={formatter && typeof formatter === 'string'? getFormatter: formatter}
          onChange={(v) => onChange(v, ref)}
          suffix={props.suffix}
          {...(!formatter ? { type: 'number' } : {})}
          {...props}
        />
      )}
      {type !== 'number' && (
        <Input
          type={type}
          value={value}
          className={`input input-transparent body-placeholder ${className} ${color}`}
          placeholder={placeholder}
          onChange={onChange}
          {...props}
        />
      )}
      {calculateBalance && (
        <div className="percentage-bottom">
          <span className="body-card">{valuePercentage}% of balance</span>
          <span className="body-regular">
            <span>$</span>
            {`${value / 2}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          </span>
        </div>
      )}
      {/* <p className="body-card">Account balance</p> */}
    </div>
  );
};

export default InputBorderNone;
